import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import Sidebar from "../common/sidebar";
import { BaseUrl } from "../common/config";
import { http } from "../helper";
import CommonAlert from "../common/Commonalert";
import ShowAlert from "../common/Showalert";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { canAction } from "../common/permissionhelper";
const MODULE = "manage_chefs";

const ChefAccountcodeEdit = () => {
  const { id } = useParams(); // ID of the record to edit
  const navigate = useNavigate();
  const { t } = useTranslation();
  const canEdit = canAction(MODULE, "edit");
  const isReadOnly = !canEdit;
  const [accountCodeOptions, setAccountCodeOptions] = useState([]);
  const [selectedCodes, setSelectedCodes] = useState("");
  const [originalCode, setOriginalCode] = useState("");
  const [restrictedCodeSet, setRestrictedCodeSet] = useState(new Set());
  const [inputValue, setInputValue] = useState("");
  const [errMessage, setErrMessage] = useState("");
  const [alertPopup, setAlertPopup] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [errorPopup, setErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  if (!sessionStorage.getItem("isLoggedIn")) {
    window.location.href = "/";
  }
  if (
    JSON.parse(sessionStorage.getItem("authData")) != "" &&
    !JSON.parse(
      sessionStorage.getItem("authData"),
    ).adminRole.permissions.includes("manage_chefs")
  ) {
    window.location.href = "/unauthorized";
  }
  // Fetch all account codes & restricted codes
  useEffect(() => {
    const fetchCodes = async () => {
      setIsLoading(true);
      try {
        const [allRes, restrictedRes, chefsRes] = await Promise.all([
          http.get(`${BaseUrl}admin/account`),
          http.get(`${BaseUrl}admin/chefaccountcodelist`),
          http.get(`${BaseUrl}admin/getchefs`),
        ]);
        const allCodes = allRes.data.data || [];
        const restrictedCodes = restrictedRes.data.data || [];
        const chefsList = chefsRes.data.data || [];
        const normalize = (val) => val?.toLowerCase()?.trim();
        const restrictedSet = new Set(
          restrictedCodes.map((item) => item.accountCode?.toLowerCase()),
        );
        setRestrictedCodeSet(restrictedSet);
        // Chef group accounts (primary + sub)
        const chefAccountSet = new Set();
        chefsList.forEach((group) => {
          if (group.primaryAccount?.accountCode) {
            chefAccountSet.add(normalize(group.primaryAccount.accountCode));
          }
          (group.accounts || []).forEach((acc) => {
            if (acc.accountCode) {
              chefAccountSet.add(normalize(acc.accountCode));
            }
          });
        });
        const originalLower = normalize(originalCode);
        // FILTER LOGIC (EDIT SAFE)
        const availableCodes = allCodes.filter((item) => {
          const code = normalize(item.accountCode);
          const isRestricted = restrictedSet.has(code);
          const isChefAccount = chefAccountSet.has(code);
          // Allow original selected code
          if (code === originalLower) return true;
          return !isRestricted && !isChefAccount;
        });
        setAccountCodeOptions(availableCodes);
        setIsLoading(false);
      } catch (err) {
        console.log(err);
        setIsLoading(false);
      }
    };
    fetchCodes();
  }, [originalCode]);
  // Fetch existing account codes for editing
  useEffect(() => {
    const fetchExisting = async () => {
      setIsLoading(true);
      try {
        const res = await http.get(`${BaseUrl}admin/chefaccountcode/${id}`);
        if (res.data.success && res.data.data) {
          // Wrap single accountCode in an array
          const existingCode = res.data.data.accountCode || "";
          setSelectedCodes(existingCode);
          setOriginalCode(existingCode);
        } else {
          setErrorPopup(true);
          setIsLoading(false);
          setErrorMessage(t("faild_fetch_acc_code_txt"));
        }
      } catch (err) {
        setErrorPopup(true);
        setIsLoading(false);
        setErrorMessage(t("error_submitting_data_txt"));
        console.log(err);
      }
    };
    if (id) fetchExisting();
  }, [id]);

  const handleCancel = () => navigate("/chef/accountcode");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setInputValue("");
    if (isReadOnly) return;
    if (!selectedCodes || selectedCodes.trim() === "") {
      setErrMessage(t("please_select_account_code_txt"));
      return;
    }
    const newCodeLower = selectedCodes.trim().toLowerCase();
    const originalLower = (originalCode || "").trim().toLowerCase();
    // If the newly selected code is restricted and is different from original, show error
    if (restrictedCodeSet.has(newCodeLower) && newCodeLower !== originalLower) {
      // Show popup and STOP the update
      setErrorPopup(true);
      setErrorMessage(t("account_already_exist_txt"));
      return;
    }
    const payload = { id, selectedAccountCodes: [selectedCodes] };
    try {
      const res = await http.put(`${BaseUrl}admin/chefaccountcode`, payload);
      if (res.data.success) {
        setAlertPopup(true);
        setIsLoading(false);
        setAlertMessage(t("acc_updated_success_txt"));
        setTimeout(() => navigate("/chef/accountcode"), 1500);
      } else {
        setErrorPopup(true);
        setErrorMessage(t("faild_update_acc_txt"));
      }
    } catch (err) {
      console.log(err);
      const backendMsg =
        err?.response?.data?.message || t("error_updating_account_code_txt");
      setErrorPopup(true);
      setErrorMessage(backendMsg);
    }
  };

  const customNoOptionsMessage = () => {
    const input = inputValue.trim().toLowerCase();
    if (restrictedCodeSet.has(input)) return null;
    if (input.length > 0) return t("no_options_txt");
    return null;
  };

  return (
    <>
      {errorPopup && (
        <ShowAlert title={t("alert_txt")} message={errorMessage} />
      )}
      {alertPopup && (
        <CommonAlert title={t("alert_txt")} message={alertMessage} />
      )}
      <div className="dashboard-block">
        <Sidebar />
        <div className="dash-left">
          <Header />
          <section className="cart-block">
            <div className="container">
              <h1 className="checkout-title">
                {canEdit ? t("edit_acc_txt") : t("view_account_code_txt")}
              </h1>
              <div className="right-table-outer-wrap">
                {isLoading ? (
                  <div className="loading-buffer"></div>
                ) : (
                  <form
                    className="addform form-container-xs"
                    onSubmit={handleSubmit}
                  >
                    <div className="input-field col-1">
                      <label>{t("account_code_txt")}</label>
                      <Select
                        isMulti={false}
                        closeMenuOnSelect={true}
                        noOptionsMessage={customNoOptionsMessage}
                        // Select expects an object {value,label} for single select
                        value={
                          selectedCodes
                            ? { value: selectedCodes, label: selectedCodes }
                            : null
                        }
                        onChange={(selectedOption) => {
                          const code = selectedOption
                            ? selectedOption.value
                            : "";
                          setSelectedCodes(code);
                          setInputValue("");
                          if (code) setErrMessage("");
                        }}
                        onInputChange={(value, { action }) => {
                          if (action === "input-change") {
                            setInputValue(value);
                            if (
                              restrictedCodeSet.has(value.trim().toLowerCase())
                            ) {
                              setErrMessage(t("account_already_exist_txt"));
                            } else {
                              setErrMessage("");
                            }
                          }
                        }}
                        inputValue={inputValue}
                        options={accountCodeOptions.map((opt) => ({
                          value: opt.accountCode,
                          label: opt.accountCode,
                        }))}
                        className="form-control"
                        placeholder={t("select_acc_code_txt")}
                        isDisabled={isReadOnly}
                        styles={{
                          menu: (base) => ({
                            ...base,
                            position: "relative",
                            zIndex: 2,
                          }),
                        }}
                      />
                      {errMessage && (
                        <div className="error-msg">{errMessage}</div>
                      )}
                    </div>
                    {!isReadOnly && <button title={t("update_btn_txt")} type="submit">{t("update_btn_txt")}</button>}
                    &nbsp;&nbsp;
                    <button title={t("cancel_txt")} type="button" onClick={handleCancel}>
                      {t("cancel_txt")}
                    </button>
                  </form>
                )}
              </div>
            </div>
          </section>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default ChefAccountcodeEdit;
